/*
包含n个接口请求函数的模块
函数的返回值: promise对象
 */
import ajax from './ajax'
import qs from 'qs'

// export const BASE_URL = 'http://192.168.0.102:8083/';//本地
// export const BASE_URL = 'http://192.168.50.60:8083/';//刘冬冬本地

// export const NEWS_STATIC_URL = 'https://secpc.qingsite.cn/';//测试环境域名
export const NEWS_STATIC_URL = 'http://www.xshangyun.com/';//正式环境域名
// 测试线上地址
// export const BASE_URL = 'https://admin.youdro.com/';

// 正式线上地址
export const BASE_URL = 'https://admin.qingshuo.net/';

//图片验证码
export const code = (x) => {
  return ajax(`${BASE_URL}user/getVerifyCode`, qs.stringify(x), 'post');
};

// export const BASE_URL = 'http://192.168.1.239:8083/';

// export const BASE_URL = 'http://qha0cf33.xiaomy.net/';

// 图片上传回显域名
export const IMGUPDATEURL = `https://osssec.mustke.com/`;

//export const login = ({username,password,verifyCode}) => {

// 推出登录

export const tLogin = (x) => {
  return ajax(`${BASE_URL}user/logOut`, qs.stringify(x), 'post');
};

// 1、登陆
export const login = (x) => {
  //return ajax(`${BASE_URL}user/login`,{username,password,verifyCode},'post');
  console.log(qs.stringify(x));
  return ajax(`${BASE_URL}user/login`, qs.stringify(x), 'post');
};

// 2、用户管理添加
export const enterpriceManagementAdd = (x) => {
  return ajax(`${BASE_URL}usermanage/addStatusModel`, qs.stringify(x), 'post');
};

// 3、用户管理编辑跳转
export const enterpriceManagementEdit = (x) => {
  return ajax(`${BASE_URL}usermanage/statusModelList`, qs.stringify(x), 'post');
};

// 4、用户管理编辑页面删除
export const enterpriceManagementEditDelete = (x) => {
  return ajax(`${BASE_URL}usermanage/delUserStatusModel`, qs.stringify(x), 'post');
};

// 5、用户管理编辑页面修改
export const enterpriceManagementEditRevise = (x) => {
  return ajax(`${BASE_URL}usermanage/updateStatusModel`, qs.stringify(x), 'post');
};

// 6、用户管理分页
export const enterpriceManagementPages = (x) => {
  return ajax(`${BASE_URL}usermanage/userList`, qs.stringify(x), 'post');
};

//用户提现记录
export const getUserWithdrawal = (x) => {
  return ajax(`${BASE_URL}usermanage/getUserWithdrawal`, qs.stringify(x), 'post');
};
//用户提现记录顶部信息
export const getUserWithdrawalTop = (x) => {
  return ajax(`${BASE_URL}usermanage/getUserWithdrawalTop`, qs.stringify(x), 'post');
};
//用户提现
export const userWithdrawal= (x) => {
  return ajax(`${BASE_URL}usermanage/userWithdrawal`,qs.stringify(x),'post');
};

// 6、用户备注
export const getRemarkRecord = (x) => {
  return ajax(`${BASE_URL}usermanage/getRemarkRecord`, qs.stringify(x), 'post');
};

// 7、用户管理标记
export const enterpriceManagementSign= (x) => {
  return ajax(`${BASE_URL}usermanage/signUserStatus`,qs.stringify(x),'post');
};

// 8、用户管理备注
export const enterpriceManagementRemark= (x) => {
  return ajax(`${BASE_URL}usermanage/remarkUserMessage`,qs.stringify(x),'post');
};

// 9、用户管理回显短信
export const enterpriceManagementgetSmsOption= (x) => {
  return ajax(`${BASE_URL}usermanage/getSmsOption`,qs.stringify(x),'post');
};
// 10、用户管理短信验证保存
export const enterpriceManagementsaveSmsOption= (x) => {
  return ajax(`${BASE_URL}usermanage/saveSmsOption`,qs.stringify(x),'post');
};
// 商户详情表格
export const enterpriceManagementmallbusinessDetails = (x) => {
  return ajax(`${BASE_URL}usermanage/findMallShopList`, qs.stringify(x), 'post');
};
enterpriceManagementbusinessOperationRecord
//商户点击详情
export const enterpriceManagementbusinessOperationRecord = (x) => {
  return ajax(`${BASE_URL}usermanage/userPath`, qs.stringify(x), 'post');
};
// 商户详情进入
export const enterpriceManagementmallShopLoginPC = (x) => {
  return ajax(`${BASE_URL}usermanage/mallShopLoginPC`, qs.stringify(x), 'post');
};

// 7、商户详情
export const enterpriceManagementbusinessDetails = (x) => {
  return ajax(`${BASE_URL}usermanage/findShopDetail`, qs.stringify(x), 'post');
};

//商户详情操作记录
export const enterpriceManagementbusinessDetailsPages = (x) => {
  return ajax(`${BASE_URL}usermanage/findOperationList`, qs.stringify(x), 'post');
};


// 8、商户详情冻结用户
export const enterpriceManagementbusinessDetailsFreeze = (x) => {
  return ajax(`${BASE_URL}usermanage/frozenUser`, qs.stringify(x), 'post');
};

// 9、商户详情修改密码
export const enterpriceManagementbusinessDetailsPassword = (x) => {
  return ajax(`${BASE_URL}usermanage/updateUserPassword`, qs.stringify(x), 'post');
};
// 9、商户修改余额提现配置
export const enterpriceManagementbusinessDetailsWithdrawOption = (x) => {
  return ajax(`${BASE_URL}usermanage/withdrawOption`, qs.stringify(x), 'post');
};

// 9、用户管理时间切换
export const enterpriceManagementTabTime = (x) => {
  return ajax(`${BASE_URL}usermanage/findShopCountByTime`, qs.stringify(x), 'post');
};

// 10、用户管理商户操作记录
export const enterpriceManagementBusinessOption = (x) => {
  return ajax(`${BASE_URL}usermanage/findOperationList`, qs.stringify(x), 'post');
};

// 11、套餐管理套餐列表
export const mealsManagementList = (x) => {
  return ajax(`${BASE_URL}package/getPackageList `, qs.stringify(x), 'post');
};

// 、套餐管理添加版本
export const mealsManagementAddEdition = (x) => {
  return ajax(`${BASE_URL}package/addPage`, qs.stringify(x), 'post');
};

// 、套餐管理添加版本保存
export const mealsManagementAddEditionKeep = (x) => {
  return ajax(`${BASE_URL}package/save`, qs.stringify(x), 'post');
};

// 、套餐订单
export const mealsOrderData = (x) => {
  return ajax(`${BASE_URL}package/pageOrderList`, qs.stringify(x), 'post');
};
//套餐管理增值服务列表
export const addServiceList = (x) => {
  return ajax(`${BASE_URL}added/getAddedServiceList `, qs.stringify(x), 'post');
};
//修改增值列表
export const setAddService = (x) => {
  return ajax(`${BASE_URL}added/editAddedService `, qs.stringify(x), 'post');
};
//套餐订单列表
export const  mealsOrderList = (x) => {
  return ajax(`${BASE_URL}package/pageOrderList `, qs.stringify(x), 'post');
};
//套餐-增值服务订单列表
export const  mealsServiceOrderList = (x) => {
  return ajax(`${BASE_URL}added/getAddedOrderList `, qs.stringify(x), 'post');
};

// 15、手动充值（添加、编辑）
export const mealsOrderEditManualRecharge= (x) => {
  return ajax(`${BASE_URL}package/editOrder`,qs.stringify(x),'post');
};
//套餐- 增值服务-弹窗保存
export const addedOrderSave= (x) => {
  return ajax(`${BASE_URL}added/addedOrderSave`,qs.stringify(x),'post');
};

// 16、手动充值弹窗搜索
export const mealsOrderManualRechargeSearch= (x) => {
  return ajax(`${BASE_URL}package/search`,qs.stringify(x),'post');
};
// 16、手动充值弹窗搜索
export const suggestPageOption= (x) => {
  return ajax(`${BASE_URL}suggest/suggestPage`,qs.stringify(x),'post');
};


// 17、手动充值弹窗保存
/*export const mealsOrderManualRechargeSave= (x) => {
  return ajax(`http://192.168.1.194:8083/package/ordersave`,qs.stringify(x),'post');
};*/

export const mealsOrderManualRechargeSave= (x) => {
  return ajax(`${BASE_URL}package/ordersave`,qs.stringify(x),'post');
};
export const upServerList= (x) => {
  return ajax(`${BASE_URL}freeLevelUp/questionList`, qs.stringify(x), 'post');
}
export const StopServerQuestion= (x) => {
  return ajax(`${BASE_URL}freeLevelUp/startOrStopQuestion`, qs.stringify(x), 'post');
}
export const ServerQuestionDetail= (x) => {
  return ajax(`${BASE_URL}freeLevelUp/questionDetails`, qs.stringify(x), 'post');
}
//保存免费升级问题
export const saveServerQuestion= (x) => {
  return ajax(`${BASE_URL}freeLevelUp/saveQuestion`, qs.stringify(x), 'post');
}
//回显升级问题
export const backQuestion= (x) => {
  return ajax(`${BASE_URL}freeLevelUp/editQuestion`, qs.stringify(x), 'post');
}
//优惠卷问题
export const CouponList= (x) => {
  return ajax(`${BASE_URL}adminCoupon/adminCouponList`, qs.stringify(x), 'post');
}
//优惠卷详情列表
export const CouponListDetail= (x) => {
  return ajax(`${BASE_URL}adminCoupon/couponDetails`, qs.stringify(x), 'post');
}

//消息管理/热搜词汇
export const hotWordsList = (x) => {
  return ajax(`${BASE_URL}news/hotWordsList`,qs.stringify(x),'post');
};
//消息管理/添加热搜词汇
export const saveWord = (x) => {
  return ajax(`${BASE_URL}news/saveWord`,qs.stringify(x),'post');
};
//消息管理/删除热搜词汇
export const delWord = (x) => {
  return ajax(`${BASE_URL}news/delWord`,qs.stringify(x),'post');
};
//消息管理/修改热搜词汇or排序
export const updateWord = (x) => {
  return ajax(`${BASE_URL}news/updateWord`,qs.stringify(x),'post');
};

//消息管理/公告列表
export const announcementList = (x) => {
  return ajax(`${BASE_URL}notice/findNoticeList`,qs.stringify(x),'post');
};

//消息管理/删除公告栏信息
export const deleteAnnouncementList = (x) => {
  return ajax(`${BASE_URL}notice/delNotice`,qs.stringify(x),'post');
};

//消息管理/添加公告
export const addAnnouncement = (x) => {
  return ajax(`${BASE_URL}notice/noticePage`,qs.stringify(x),'post');
};

//消息管理/添加公告/保存
export const addAnnouncementSave = (x) => {
  return ajax(`${BASE_URL}notice/manageNotice`,qs.stringify(x),'post');
};

//消息管理/新闻分类
export const newClassification = (x) => {
  return ajax(`${BASE_URL}newstype/getList`,qs.stringify(x),'post');
};

//消息管理/新闻分类/添加分类
export const addNewClassification = (x) => {
  return ajax(`${BASE_URL}newstype/save_add`,qs.stringify(x),'post');
};

//消息管理/新闻分类/删除分类
export const deleteNewClassification = (x) => {
  return ajax(`${BASE_URL}newstype/del`,qs.stringify(x),'post');
};

//消息管理/新闻分类/修改获取信息
export const editGetNewClassification = (x) => {
  return ajax(`${BASE_URL}newstype/edit`,qs.stringify(x),'post');
};

//消息管理/新闻分类/修改保存
export const editNewClassificationSave = (x) => {
  return ajax(`${BASE_URL}newstype/save_edit`,qs.stringify(x),'post');
};


//消息管理/新闻分类/修改操作
export const editNewClassification = (x) => {
  return ajax(`${BASE_URL}newstype/save_edit`,qs.stringify(x),'post');
};

//消息管理/新闻标签
export const newsLabel = (x) => {
  return ajax(`${BASE_URL}newslable/getList`,qs.stringify(x),'post');
};

//消息管理/新闻标签/添加标签
export const addNewsLabel = (x) => {
  return ajax(`${BASE_URL}news/addLable`,qs.stringify(x),'post');
};

//消息管理/新闻标签/推荐
export const newsLabelRecommend = (x) => {
  return ajax(`${BASE_URL}newslable/updatetj`,qs.stringify(x),'post');
};
//消息管理/意见反馈/列表
export const feedbackList = (x) => {
  return ajax(`${BASE_URL}suggest/suggestList`,qs.stringify(x),'post');
};
//消息管理/意见反馈/详情
export const feedbackListDetail = (x) => {
  return ajax(`${BASE_URL}suggest/suggestDetails`,qs.stringify(x),'post');
};
//消息管理/意见反馈/处理结果
export const feedbackResult = (x) => {
  return ajax(`${BASE_URL}suggest/disposeSuggest`,qs.stringify(x),'post');
};

//管理员管理/管理员列表
export const administratorsList = (x) => {
  return ajax(`${BASE_URL}administrator/administratorList`,qs.stringify(x),'post');
};

//管理员管理/删除管理员
export const deleteAdministrators = (x) => {
  return ajax(`${BASE_URL}administrator/delAdministrator`,qs.stringify(x),'post');
};
//消息管理/投诉/列表
export const complaintList = (x) => {
  return ajax(`${BASE_URL}suggest/wxSuggestPage`,qs.stringify(x),'post');
};

//消息管理/投诉/详情
export const complaintDetail = (x) => {
  return ajax(`${BASE_URL}suggest/wxSuggestDetails`,qs.stringify(x),'post');
};
//消息管理/投诉/处理结果
export const complaintResult = (x) => {
  return ajax(`${BASE_URL}suggest/wxDisposeSuggest`,qs.stringify(x),'post');
};
//管理员管理/添加(编辑)管理员
export const addAdministrators = (x) => {
  return ajax(`${BASE_URL}administrator/page`,qs.stringify(x),'post');
};

//管理员管理/添加(编辑)管理员保存
export const addAdministratorSure = (x) => {
  return ajax(`${BASE_URL}administrator/saveAdministrator`,qs.stringify(x),'post');
};

//管理员管理/操作日志列表
export const operationLog = (x) => {
  return ajax(`${BASE_URL}administrator/logList`,qs.stringify(x),'post');
};

//配置管理/网站配置
export const websiteConfiguration = (x) => {
  return ajax(`${BASE_URL}configuration/webSetPage`,qs.stringify(x),'post');
};

//配置管理/网站配置保存
export const websiteConfigurationSave = (x) => {
  return ajax(`${BASE_URL}configuration/saveWebSet`,qs.stringify(x),'post');
};

//配置管理/订单配置
export const orderConfiguration = (x) => {
  return ajax(`${BASE_URL}configuration/orderSetPage`,qs.stringify(x),'post');
};

//配置管理/订单配置保存
export const orderConfigurationSave = (x) => {
  return ajax(`${BASE_URL}configuration/saveOrderSet`,qs.stringify(x),'post');
};

//配置管理/订单配置删除
export const orderConfigurationdelete = (x) => {
  return ajax(`${BASE_URL}configuration/delOrderSet`,qs.stringify(x),'post');
};
//配置管理/网站配置
export const baseSetting = (x) => {
  return ajax(`${BASE_URL}configuration/baseSetPage`,qs.stringify(x),'post');
};
export const saveBaseSetting = (x) => {
  return ajax(`${BASE_URL}configuration/saveBaseSet`,qs.stringify(x),'post');
};

// 、首页
export const index = (x) => {
  return ajax(`${BASE_URL}homepage/homeDetail`,qs.stringify(x),'post');
};

//域名配置
export const area = (x) => {
  return ajax(`${BASE_URL}across/auditList`,qs.stringify(x),'post');
};



/*export const reqAddress = ({name,password}) => {
  console.log({name,password});
  return ajax(`${BASE_URL}appapi.php`,{name,password},'post');
};*/

/*
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.needLog)) {
    //页面是否登录
    if (!localStorage.getItem("zero_token")) {
      //next可以传递一个路由对象作为参数 表示需要跳转到的页面
      next({
        path: "/log"
      });
    }
    if(false){

    }
    //本地存储中是否有token(uid)数据
    next(); //表示已经登录
  } else {
    //表示不需要登录
    next(); //继续往后走
  }
})

*/


// =========================== 新闻模块 =============================================

// 新闻分类列表
export const NewList = (x) =>{
  return ajax(`${BASE_URL}news/getList`,qs.stringify(x),'post')
}
// 删除新闻
export const NewListDel = (x) =>{
  return ajax(`${BASE_URL}news/del`,qs.stringify(x),'post')
}

//新闻列表、静态化
export const NewListStatic = (x) =>{
  return ajax(`${NEWS_STATIC_URL}helpcenter/staticHtml`,qs.stringify(x),'post')
  //return ajax(`https://192.168.1.194:8081/helpcenter/staticHtml`,qs.stringify(x),'post')
}

// 添加新闻
export const NewListAdd = (x) =>{
  return ajax(`${BASE_URL}news/save_add`,qs.stringify(x),'post')
}

//新闻列表/修改新闻获取数据
export const editNew = (x) =>{
  return ajax(`${BASE_URL}news/edit`,qs.stringify(x),'post')
};

//新闻列表/修改新闻保存
export const editNewSave = (x) =>{
  return ajax(`${BASE_URL}news/save_edit`,qs.stringify(x),'post')
};

//消息管理/新闻列表/添加新闻/新闻分类
export const NewListClasslist = (x) =>{
  return ajax(`${BASE_URL}news/add`,qs.stringify(x),'post')
};
// 新闻图片上传
export const uploadImg = (x) =>{
  return ajax(`${BASE_URL}file/img`,qs.stringify(x),'post')
}
// 标签列表
export const AddNewGetList = (x) =>{
  return ajax(`${BASE_URL}newslable/getList`,qs.stringify(x),'post')
}
// 富文本上传图片
export const editImg = `${BASE_URL}file/kinder_edit_img`;
// 认证管理列表单店铺
export const getCertificationList = (x) =>{
  return ajax(`${BASE_URL}certification/getCertificationData`,qs.stringify(x),'post')
}
// 认证管理列表平台、多店铺
export const mallCertification = (x) =>{
  return ajax(`${BASE_URL}certification/mallCertification`,qs.stringify(x),'post')
}

// 认证外卖
export const getCertificationDataThree = (x) =>{
  return ajax(`${BASE_URL}certification/getCertificationDataThree`,qs.stringify(x),'post')
}
// 认证管理列表-审核状态
export const handAuthleStatus = (x) =>{
  return ajax(`${BASE_URL}certification/agreeOrDisagreeOrReset`,qs.stringify(x),'post')
}
// 认证管理列表-详情
export const AuthDetails = (x) =>{
  return ajax(`${BASE_URL}certification/CertificationDetails`,qs.stringify(x),'post')
}
// 认证管理列表
export const getMallList = (x) =>{
  return ajax(`${BASE_URL}certification/getMallList`,qs.stringify(x),'post')
}

// 模板列表接口
export const shopTemplateList = (x) =>{
  return ajax(`${BASE_URL}configuration/shopTemplateList`,qs.stringify(x),'post')
}

//添加模板接口
export const addShopTemplate = (x) =>{
 return ajax(`${BASE_URL}configuration/addShopTemplate`,qs.stringify(x),'post')
}

//修改获取模板信息接口
export const getShopTemplate = (x) => {
  return ajax(`${BASE_URL}configuration/getShopTemplate`,qs.stringify(x),'post')
}

//删除获取模板接口
export const delShopTemplate = (x) => {
  return ajax(`${BASE_URL}configuration/delShopTemplate`,qs.stringify(x),'post')
}

//更新获取模板接口
export const updateShopTemplate = (x) => {
  return ajax(`${BASE_URL}configuration/updateShopTemplateSort`,qs.stringify(x),'post')
}

// 分类列表
export const getGoodsType = (x) => {
  return ajax(`${BASE_URL}sysClass/getGoodsType`,qs.stringify(x),'post')
}
// 添加一级分类
export const addModule = (x) => ajax(`${BASE_URL}sysClass/addModule`,qs.stringify(x),'post');
// 添加二级分类
export const addOtherModule = (x) => ajax(`${BASE_URL}sysClass/addOtherModule`,qs.stringify(x),'post');
// 修改分类
export const reviseModule = (x) => ajax(`${BASE_URL}sysClass/reviseModule`,qs.stringify(x),'post');
// 删除分类
export const delModule = (x) => ajax(`${BASE_URL}sysClass/delModule`,qs.stringify(x),'post');

// 商品列表
export const getProductList = (x) => ajax(`${BASE_URL}sysGoods/getProductList`,qs.stringify(x),'post');
// 添加商品
export const addGoodsPost = (x) => ajax(`${BASE_URL}sysGoods/addGoodsPost`,qs.stringify(x),'post');
// 删除单个商品
export const deleteOne = (x) => ajax(`${BASE_URL}sysGoods/deleteOne`,qs.stringify(x),'post');
// 获取商品信息
export const getGoodsInfo = (x) => ajax(`${BASE_URL}sysGoods/getGoodsInfo`,qs.stringify(x),'post');
// 修改商品
export const editGoodsPost = (x) => ajax(`${BASE_URL}sysGoods/editGoodsPost`,qs.stringify(x),'post');
// 商品一级分类
export const getCategoryOne = (x) => ajax(`${BASE_URL}sysClass/getCategoryOne`,qs.stringify(x),'post');
// 获取二级分类
export const getCategoryTwo = (x) => ajax(`${BASE_URL}sysClass/getCategoryTwo`,qs.stringify(x),'post');




// WEBPACK FOOTER //
// ./src/api/index.js